// generated file
export const appVersion = '0.9.3';
